import makeStyles from 'e100-react-components/lib/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  container: {
    minWidth: '325px',
  },
}));
